import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const createSignature = async (data: any) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post<ApiResponse>(
      `${API_BASE_URL}/create_signature/`,
      data,
      config
    );
    console.log(response)
    return response.data;
  } catch (error) {}
};

const getSignatures = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_signature/`);
    return data;
  } catch (error) {
    return error;
  }
};

const editSignature = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/edit_signature/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const deleteSignature = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/delete_signature/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const SignatureController = {
  createSignature,
  getSignatures,
  editSignature,
  deleteSignature
};

export default SignatureController;
